module.exports = __webpack_public_path__ + "img/web_invite.7a322c36.gif";